import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Registrar o desregistrar Service Worker según configuración de la PWA
if ('serviceWorker' in navigator && (window.location.protocol === 'https:' || window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1')) {
  window.addEventListener('load', () => {
    try {
      const cached = localStorage.getItem('agencia_site_config') || localStorage.getItem('dxn_site_config');
      if (cached) {
        const parsed = JSON.parse(cached);
        if (parsed.pwa_activo === '0' || parsed.pwa_activo === false || parsed.pwa_activo === 'false') {
          // Desregistrar service workers si la PWA está desactivada
          navigator.serviceWorker.getRegistrations().then((registrations) => {
            for (let reg of registrations) {
              reg.unregister();
            }
          });
          return;
        }
      }
    } catch (e) {}

    navigator.serviceWorker.register('/sw.js').catch((error) => {
      console.log('Error registrando Service Worker PWA:', error);
    });
  });
}

reportWebVitals();
